import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { SidebarClose } from 'lucide-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { JobsFilters } from './jobsFilters';

const FiltersTitleText = styled.div`
  color: ${({ theme }) => theme.colors.text.dark};
  font-weight: 600;
  line-height: 1.4;
  font-size: 16px;
`;

export const JobsSidebar = ({
  toggleFilters,
  jobsFilters,
  filterOrSortJobs,
  updateQueryString,
  sourceOptions,
  statusOptions,
  visibilityOptions,
  seniorityOptions,
  featuredOptions,
  expirationOptions,
  equityOptions,
  hideCompanyFilter,
  isCompanyProfile,
  filtersCount,
  showFilters,
  isSourcingAgent,
  hasConnect,
}) => (
  <Box
    sx={{
      bg: 'neutral.0',
      width: '264px',
      transform: showFilters ? 'translateX(0%)' : 'translateX(-100%)',
      opacity: showFilters ? '1' : '0',
      transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
      flexShrink: 0,
      overflow: 'hidden',
      zIndex: 2,
      height: '100%',
    }}
  >
    <Box
      sx={{
        maxWidth: '264px',
        position: 'relative',
        borderRight: '1px solid',
        borderColor: 'border.subtle',
        height: '100%',
      }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width="24px"
        height="24px"
        color="neutral.400"
        sx={{ cursor: 'pointer', position: 'absolute', top: '4px', right: '12px', zIndex: 10 }}
        onClick={toggleFilters}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleFilters();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Close filters"
      >
        <Box as={SidebarClose} className="main-menu-item" width="16px" height="16px" flex="0 0 auto" />
      </Flex>
      <Flex flex="0 0 auto" flexDirection="column" sx={{ position: 'relative', height: '100%' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '8px 16px 16px 16px',
          }}
        >
          <FiltersTitleText data-testid="jobs-filters-title">Filters</FiltersTitleText>
        </div>
        <JobsFilters
          jobsFilters={jobsFilters}
          filterOrSortJobs={filterOrSortJobs}
          updateQueryString={updateQueryString}
          sourceOptions={sourceOptions}
          statusOptions={statusOptions}
          visibilityOptions={visibilityOptions}
          seniorityOptions={seniorityOptions}
          featuredOptions={featuredOptions}
          expirationOptions={expirationOptions}
          equityOptions={equityOptions}
          hideCompanyFilter={hideCompanyFilter}
          isCompanyProfile={isCompanyProfile}
          isSourcingAgent={isSourcingAgent}
          hasConnect={hasConnect}
          sx={{
            height: '100%',
            maxHeight: filtersCount > 0 ? 'calc(100vh - 160px)' : '100%',
            pb: '10px',
          }}
        />
      </Flex>
    </Box>
  </Box>
);

JobsSidebar.propTypes = {
  toggleFilters: PropTypes.func.isRequired,
  jobsFilters: PropTypes.object.isRequired,
  filterOrSortJobs: PropTypes.func.isRequired,
  updateQueryString: PropTypes.func.isRequired,
  sourceOptions: PropTypes.array,
  statusOptions: PropTypes.array,
  visibilityOptions: PropTypes.array,
  seniorityOptions: PropTypes.array,
  featuredOptions: PropTypes.array,
  expirationOptions: PropTypes.array,
  equityOptions: PropTypes.array,
  hideCompanyFilter: PropTypes.bool,
  isCompanyProfile: PropTypes.bool,
  filtersCount: PropTypes.number,
  showFilters: PropTypes.bool,
  isSourcingAgent: PropTypes.bool,
  hasConnect: PropTypes.bool,
};

JobsSidebar.defaultProps = {
  sourceOptions: [],
  statusOptions: [],
  visibilityOptions: [],
  seniorityOptions: [],
  featuredOptions: [],
  expirationOptions: [],
  equityOptions: [],
  hideCompanyFilter: false,
  isCompanyProfile: false,
  filtersCount: 0,
  showFilters: false,
  isSourcingAgent: false,
  hasConnect: false,
};
